'use strict';

module.exports = /*@ngInject*/ function($scope, $log) {
	// var vm = this;

};